import UserGroupHelperServices from "../../Reducers/UserGroups/UserGroupResponseHelper";
import * as actions from "../../ActionType/UserActionType";
const dispatchAction:any=(dispatch:any ,actionType:any, data:any,  error:string, message:string)=>{
    dispatch({type:actionType,payload:data, message:message});
};
class UserGroupServicesApi {
    createUserGroup = (groupParam:any,customerId:any,accessToken:any,notifySuccess:any,ErrorMessage:any) =>async (dispatch:any )=> {
       try{
        const createGroups = await UserGroupHelperServices.CREATE_USERS_GROUP(groupParam,customerId,accessToken);
        if(createGroups?.name){
            let download:any = 'download';
            notifySuccess(createGroups,download)
            dispatchAction(dispatch, actions.CREATE_USER_GROUP, createGroups)
        }else{
            let createUserGroup:any = 'createUserGroup';
            ErrorMessage(createGroups,createUserGroup)
            dispatchAction(dispatch,actions.CREATE_USER_GROUP, createGroups, [], 'Invalid userGroup !')
        }
       }catch(error){console.log('create user group error  ==>',error)}
    };
    updateUserGroup = (groupParam:any,userGroupId:any,accessToken:any,enqueueSnackbar:any) =>async (dispatch:any )=> {
        try{
         const updateGroups = await UserGroupHelperServices.UPDATE_USERS_GROUP(groupParam,userGroupId,accessToken);
         if(updateGroups){
            updateGroups?.error?
            enqueueSnackbar(updateGroups?.error?.message, { variant: 'error' }):
             dispatchAction(dispatch, actions.UPDATE_USER_GROUP, updateGroups)
             (enqueueSnackbar('Success!', { variant: 'success' }))
         }else{
             dispatchAction(dispatch,actions.UPDATE_USER_GROUP, updateGroups, [], 'Invalid userGroup !')
         }
        }catch(error){console.log('update user group error  ==>',error)}
     };
  allUsersGroup = (customerId:number, accessToken:any,enqueueSnackbar:any) =>async (dispatch:any )=> {
    try{
     const AllUserGroups = await UserGroupHelperServices.ALL_USERS_GROUP(customerId, accessToken);
     if(AllUserGroups){
        AllUserGroups?.error?
        enqueueSnackbar(AllUserGroups?.error?.message, { variant: 'error' }):
         dispatchAction(dispatch, actions.ALL_USER_GROUP, AllUserGroups)
     }else{
         dispatchAction(dispatch,actions.ALL_USER_GROUP, AllUserGroups, [], 'Invalid userGroup !')
     }
    }catch(error){console.log('create user group error  ==>',error)}
 };
 deleteUsersGroup = (userGroupId:any,accessToken:any,enqueueSnackbar:any) =>async (dispatch:any )=> {
    try{
     const deleteGroups = await UserGroupHelperServices.DELETE_USERS_GROUP(userGroupId,accessToken);
     if(deleteGroups){
        deleteGroups?.error?
        enqueueSnackbar(deleteGroups?.error?.message, { variant: 'error' }):
         dispatchAction(dispatch, actions.CREATE_USER_GROUP, deleteGroups)
         (enqueueSnackbar('Success!', { variant: 'success' }))
     }else{
         dispatchAction(dispatch,actions.CREATE_USER_GROUP, deleteGroups, [], 'Invalid delete userGroup !')
     }
    }catch(error){console.log('delete user group error  ==>',error)}
 };
 getIdByUsersGroup = (userId:any,accessToken:any) =>async (dispatch:any )=> {
    try{
     const getIdByGroups = await UserGroupHelperServices.GET_ID_BY_USERS_GROUP(userId,accessToken);
     if(getIdByGroups){
         dispatchAction(dispatch, actions.GET_USER_GROUP_BYID, getIdByGroups)
     }else{
         dispatchAction(dispatch,actions.GET_USER_GROUP_BYID, getIdByGroups, [], 'Invalid get by id userGroup !')
     }
    }catch(error){console.log('get by id user group error  ==>',error)}
 };
 assignUsersGroup = (userGroup:any,accessToken:any,enqueueSnackbar:any) =>async (dispatch:any )=> {
    try{
     const formUsersGroups = await UserGroupHelperServices.ASSIGN_GROUP_ADD_USER(userGroup,accessToken);
     if(formUsersGroups){
       if(formUsersGroups?.error){
           enqueueSnackbar(formUsersGroups?.error?.message, { variant: 'error' })
       }else{
           dispatchAction(dispatch, actions.ADD_USER_FORM_GROUP, formUsersGroups)
           enqueueSnackbar('Success!', { variant: 'success' })
       }
     }else{
         dispatchAction(dispatch,actions.ADD_USER_FORM_GROUP, formUsersGroups, [], 'Invalid form userGroup !')
     }
    }catch(error){console.log('form user group error  ==>',error)}
 };
 ftpProcessApi = (userId:any,accessToken:any) =>async (dispatch:any )=> {
    try{
     const ftp = await UserGroupHelperServices.PROCESS_FTP(userId,accessToken);
     if(ftp){
         dispatchAction(dispatch, actions.FTP_PROCESS, ftp)
     }else{
         dispatchAction(dispatch,actions.FTP_PROCESS, ftp, [], 'Invalid ftp process !')
     }
    }catch(error){console.log(' ftp process error  ==>',error)}
 };
}
export default new UserGroupServicesApi();